"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toValues = void 0;
exports.toValues = (obj) => Object.keys(obj).map(k => obj[k]);
//# sourceMappingURL=toValues.js.map